import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { purgeLegacyApiEntries } from './services/apiCache';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality (production only - a service
// worker in dev mode cache-first-serves stale bundles and survives normal
// page refreshes, masking real dev-server output).
if (process.env.NODE_ENV === 'production') {
  // Service workers before 2026-09-27 kept every API response, other members'
  // data included, and the old worker may still be in charge until its
  // replacement activates. Clear what it left rather than wait for that.
  purgeLegacyApiEntries();
  serviceWorkerRegistration.register({
    onSuccess: () => {
      console.log('PWA: Content is cached for offline use');
    },
    onUpdate: (registration) => {
      console.log('PWA: New content is available');
      // Notify the App component that an update is available
      if (window.onServiceWorkerUpdate) {
        window.onServiceWorkerUpdate(registration);
      }
    }
  });
}
